'use client'

import * as React from 'react'
import * as TogglePrimitive from '@radix-ui/react-toggle'
import { mtc } from '../../../utils/style-helpers'
import { Icon } from '../icon'
import { faBarsFilter, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { toggleStyle } from './styles'

type FilterToggleProps = React.ComponentPropsWithoutRef<
  typeof TogglePrimitive.Root
>

export const FilterToggle: React.FC<FilterToggleProps> = ({
  className,
  children,
  pressed: pressedProp,
  onPressedChange,
  ...props
}) => {
  const [internalPressed, setInternalPressed] = React.useState(false)

  const isControlled = pressedProp !== undefined
  const pressed = isControlled ? pressedProp : internalPressed

  const handlePressedChange = (newPressed: boolean) => {
    if (!isControlled) {
      setInternalPressed(newPressed)
    }
    onPressedChange?.(newPressed)
  }

  return (
    <TogglePrimitive.Root
      className={mtc(toggleStyle(), className)}
      pressed={pressed}
      onPressedChange={handlePressedChange}
      {...props}
    >
      {pressed ? (
        <Icon icon={faBarsFilter} color="text-green-100" />
      ) : (
        <Icon icon={faPlus} color="text-neutral-500" />
      )}
      {children}
    </TogglePrimitive.Root>
  )
}

FilterToggle.displayName = 'FilterToggle'
